
<template>
  <Card class="insights-card feedback-card">
    <template #title>
      <div class="card-title feedback-title">
        <i class="pi pi-chart-bar card-icon" />
        Performance Feedback
      </div>
    </template>
    <template #content>
      <div class="feedback-columns">
        <div class="feedback-column good-col">
          <div class="column-header good">
            <i class="pi pi-check-circle" />
            <span>What went well</span>
          </div>
          <ul
            v-if="feedback.good_points && feedback.good_points.length"
            class="points-list"
          >
            <li
              v-for="(point, index) in feedback.good_points"
              :key="index"
              class="point-item good"
            >
              {{ point }}
            </li>
          </ul>
          <p
            v-else
            class="empty-points"
          >
            No feedback available.
          </p>
        </div>

        <div class="feedback-column bad-col">
          <div class="column-header bad">
            <i class="pi pi-exclamation-circle" />
            <span>Areas to improve</span>
          </div>
          <ul
            v-if="feedback.bad_points && feedback.bad_points.length"
            class="points-list"
          >
            <li
              v-for="(point, index) in feedback.bad_points"
              :key="index"
              class="point-item bad"
            >
              {{ point }}
            </li>
          </ul>
          <p
            v-else
            class="empty-points"
          >
            No improvements noted.
          </p>
        </div>
      </div>
    </template>
  </Card>
</template>

<script>
import Card from 'primevue/card'

export default {
  name: 'InsightsFeedback',
  components: { Card },
  props: {
    feedback: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.insights-card {
  width: 100%;
  border-radius: 14px;
  border: 1.5px solid #9110b9;
  box-shadow: 0 2px 10px #047857;
  margin-bottom: 0;
  padding: 0;
}

.feedback-card {
  border-color: #047857;
}

.card-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1.08rem;
  font-weight: 700;
  color: #047857;
  padding: 10px 0 0 0;
}

.feedback-title {
  color: #047857;
}

.card-icon {
  color: #10b981;
  font-size: 1.2rem;
}

.feedback-columns {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: stretch;
}

@media (min-width: 768px) {
  .feedback-columns {
    flex-direction: row;
    gap: 12px;
  }
}

.feedback-column {
  flex: 1;
  min-width: 0;
  background: #ffffff;
  border-radius: 10px;
  border: 0.5px solid;
  padding: 12px 14px;
  text-align: left;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.good-col {
  border-color: #208f33;
  box-shadow: 0 0 0 3px rgba(32, 143, 51, 0.18), 0 2px 8px rgba(32, 143, 51, 0.1);
}
.bad-col {
  border-color: #d83403;
  box-shadow: 0 0 0 3px rgba(216, 52, 3, 0.18), 0 2px 8px rgba(216, 52, 3, 0.1);
}

.column-header {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 700;
  margin-bottom: 12px;
  font-size: 0.97rem;
}
.column-header.good {
  color: #208f33;
}
.column-header.bad {
  color: #d83403;
}

.points-list {
  padding-left: 16px;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.point-item {
  line-height: 1.5;
  color: #374151;
  font-size: 0.97rem;
}

.empty-points {
  margin: 0;
  color: #9ca3af;
  font-style: italic;
  font-size: 0.95rem;
}
</style>
